import React, { useEffect } from 'react';
import DisclosureSearchView from '../../components/Workflow-esg/views/DisclosureSearchView';
import { useNavigationContext } from "../../../common/navigation/NavigationContext";
import DefinitionsOrchestrationController from "../controller/DefinitionsOrchestrationController";

export default function DefinitionsOrchestrationView() {
  const userId = sessionStorage.getItem("SEC_USER_GUID") || "SYSTEM_USER";
  const s3Key = "BaseStructure/Exiobase_Taxonomy_Standard.json";

  const logic = DefinitionsOrchestrationController(userId, s3Key);
  const { setWorkflowContext } = useNavigationContext();

  useEffect(() => {
    setWorkflowContext(
      "Refresh ESG Taxonomy",
      "/registered/site-admin/taxonomy-workflow"
    );
    logic.executeDisclosureSearch(); 
  }, [setWorkflowContext]); // eslint-disable-line react-hooks/exhaustive-deps

  const activeElement = logic.selectedElements[logic.activeElementId];

  return (
    <div className="page-main mt-5 pt-5" data-scroll-container>
      <div className="page-main-inner">
        <section className="page-section px-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-8">
                
                {/* 🎯 HEADER: Consistent with WorkflowHub.jsx */}
                <div className="d-flex justify-content-between align-items-end mb-4 border-bottom pb-3">
                  <h2 className="h4 fw-bold mb-1 text-dark">
                    Report Definition Orchestrator
                  </h2>
                  <div className="text-end text-muted extra-small text-uppercase fw-bold">
                    Context: Definition & Mapping
                  </div>
                </div>

                {/* 🎯 STEP 1: DISCOVERY CARD (Clean Room Aesthetic) */}
                <div className="card shadow-sm border-0 bg-white overflow-hidden mb-4">
                  <div className="card-header bg-white py-3 border-bottom d-flex justify-content-between align-items-center">
                    <h6 className="mb-0 fw-bold text-primary">1. Taxonomy Discovery & Selection</h6>
                    <button 
                      className="btn btn-xs btn-outline-primary fw-bold" 
                      onClick={logic.executeDisclosureSearch}
                      disabled={logic.isSearching}
                    >
                      {logic.isSearching ? "SEARCHING..." : "REFRESH TAXONOMY"}
                    </button>
                  </div>
                  <div className="card-body p-0">
                    <DisclosureSearchView 
                      searchTerm={logic.searchTerm}
                      setSearchTerm={logic.setSearchTerm}
                      results={logic.disclosure_results}
                      isSearching={logic.isSearching}
                      onSearch={logic.executeDisclosureSearch}
                      canSelect={true}
                      onAdd={logic.addElement}
                    />
                  </div>
                </div>

                {/* 🎯 STEP 2: SELECTED HIERARCHY CARD */}
                <div className="card shadow-sm border-0 bg-white overflow-hidden mb-4 animate__animated animate__fadeIn">
                  <div className="card-header bg-white py-3 border-bottom">
                    <h6 className="mb-0 fw-bold text-primary">2. Active Reporting Hierarchy</h6>
                  </div>
                  <div className="card-body p-0">
                    <div className="list-group list-group-flush">
                      {Object.values(logic.selectedElements).length > 0 ? (
                        Object.values(logic.selectedElements).map(el => (
                          <div 
                            key={el.naceId} 
                            className={`d-flex align-items-center px-4 py-3 cursor-pointer hover-bg-light border-bottom ${logic.activeElementId === el.naceId ? "bg-light" : ""}`}
                            onClick={() => logic.setActiveElementId(el.naceId)}
                          >
                            <div className="flex-grow-1">
                                <span className="fw-bold small text-dark">{el.label}</span>
                                <code className="ms-2 extra-small text-primary">{el.naceId}</code>
                            </div>
                            <button 
                              className="btn btn-link text-danger p-0 ms-3" 
                              onClick={(e) => { e.stopPropagation(); logic.removeElement(el.naceId); }}
                            >
                              <i className="bi bi-trash small"></i>
                            </button>
                          </div>
                        ))
                      ) : (
                        <div className="p-5 text-center text-muted small italic bg-light border-dashed">
                          Add elements from the discovery tool to begin mapping.
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* 🎯 STEP 3: DEFINITION GATE (Context Sensitive) */}
                {activeElement && (
                  <div className="card shadow-sm border-0 bg-white overflow-hidden mt-4 animate__animated animate__fadeInUp">
                    <div className="card-header bg-white py-3 border-bottom d-flex justify-content-between align-items-center">
                      <h6 className="mb-0 fw-bold text-primary">3. Field Definition: {activeElement.naceId}</h6>
                      <span className="badge bg-primary bg-opacity-10 text-primary border border-primary-subtle px-3 py-2 fw-bold">
                         <i className="bi bi-gear-fill me-1"></i> MAPPING MODE
                      </span>
                    </div>
                    <div className="card-body p-4 bg-light">
                        <div className="p-3 bg-white rounded border shadow-sm mb-4">
                          <label className="extra-small fw-bold text-muted text-uppercase mb-2 d-block">Regulatory Reference</label>
                          <div className="fw-bold text-dark">{activeElement.label}</div>
                          <div className="text-muted small mt-1">Impact Contexts: {activeElement.contexts?.map(c => c.uid).join(", ") || "N/A"}</div>
                        </div>

                        {/* FINAL SAVE ACTION STYLE FROM VALIDATION VIEW */}
                        <div className="d-grid">
                          <button className="btn btn-success btn-lg fw-bold shadow">
                            SAVE DEFINITION TO S3
                          </button>
                        </div>
                    </div>
                  </div>
                )}

                {/* FOOTER: Matches WorkflowHub exactly */}
                <div className="mt-5 pt-4 border-top d-flex justify-content-between align-items-center">
                  <button
                    type="button"
                    className="btn btn-link text-decoration-none p-0 text-secondary small d-flex align-items-center"
                    onClick={() => window.history.back()}
                  >
                    <i className="bi bi-arrow-left me-2"></i>
                    Return to Previous Step
                  </button>
                </div>

              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}